import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {
      gender: {
        title: 'Naziv',
        select: 'Izberite',
        error: 'Izberite svoj naziv.'
      },
      name: {
        title: 'Ime',
        error: 'Vpišite svoje ime.'
      },
      lastName: {
        title: 'Priimek',
        error: 'Vpišite svoj priimek.'
      },
      email: {
        title: 'E-pošta',
        error: 'Vpišite svoj e-mail naslov.'
      },
      telephone: {
        title: 'Telefon',
        error: 'Vpišite svojo telefonsko številko.'
      },
    },
    gdpr: {
      title: 'Potrditev',
      error: 'Označili ste DA pri najmanj eni vrsti sporočil, zato prosimo izberite najmanj en način obveščanja.',
      terms: {
        helpText: 'S posredovanjem osebnih podatkov dovoljujem, da GA Adriatic, d.o.o. sam ali izbrani pooblaščeni trgovec Nissan uporabljata osebne podatke, navedene v zgornjem obrazcu, za namene izvedbe storitve v časovnem obdobju, potrebnem za izvedbo storitve, oz. najdlje 3 leta.',
        helpText2: 'Vodenje, nadzor in upravljanje zbirke osebnih podatkov ter posredovanje podatkov tretjim natančno določata Pravilnik VOP podjetja GA Adriatic, d.o.o. in Katalog osebnih podatkov, ki jih upravlja GA Adriatic, d.o.o. Več o splošnih informacijah o varstvu podatkov si lahko preberem <a href="https://www.nissan.si/splosno-vop" target"_blank">TUKAJ</a>. V primeru zlorabe mojih podatkov se lahko obrnem na GA Adriatic, d.o.o. na e-naslov: <a href="mailto:SI-Nissan-vop@grandautomotive.eu">SI-Nissan-vop@grandautomotive.eu</a>.'
      },
      disclosure: {
        text1Title: 'Seznanjen(a) sem z informacijami o obdelavi<br>osebnih podatkov GA Adriatic.',
        textSubtitle: 'Prosimo, obvezno preberite.',
        text1Bullet1: '1. Upravljavec osebnih podatkov<br>GA Adriatic d.o.o., Dunajska 22, 1000 Ljubljana, pravna oseba, ki na slovenskem trgu zastopa znamke Renault, Dacia, Nissan in Alpine ter pooblaščeni trgovci znamk, kjer se nahajajo vaši podatki (seznam je objavljen na <a href="https://www.nissan.si/trgovci" target="_blank">www.nissan.si/trgovci</a>) kot skupni upravljavci podatkov.<br> Za vsa vprašanja glede obdelave podatkov ali vaših pravic se obrnite na pooblaščeno osebo za zaščito podatkov: <a href="mailto:SI-Nissan-vop@grandautomotive.eu">SI-Nissan-vop@grandautomotive.eu</a>.',
        text1Bullet2: '2. Namen obdelave osebnih podatkov<br>GA Adriatic d.o.o. sam ali izbrani pooblaščeni trgovec uporabljata vaše osebne podatke, ki ste jih posredovali prek te spletne strani, za namen obdelave vaše zahteve iz tega obrazca, v roku, ki je potreben za izvedbo storitve. Vaši podatki se lahko uporabijo za anketiranje o zadovoljstvu, za pošiljanje komercialnih ponudb za nakup vozil in poprodajnih izdelkov ter informacij o osebnih ugodnostih, dogodkih in drugih aktualnih novic.',
        text1Bullet3: '3. Osebni podatki<br>Osebni podatki ime, priimek, telefonska številka, e-poštni naslov, označeni z (*), so obvezni za obdelavo vaše zahteve iz tega spletnega obrazca; Če jih ne posredujete, vaše zahteve ne moremo obdelati. Osebni podatki, obdelani za namene pošiljanja komercialnih ponudb: ime, priimek, naslov, telefonska številka, e-naslov, socio-demografski podatki (če je dovoljeno), zgodovinske informacije o nakupu (če je dovoljeno).',
        text1Bullet4: '4. Pravna podlaga<br> Upravljanje vaših zahtevkov v okviru pogodbene obveznosti (obdelava vaše zahteve, navedene v tem obrazcu), zakonitega interesa (anketa o zadovoljstvu) in vaše privolitve (pošiljanje komercialnih ponudb).',
        text1Bullet5: '5. Prejemniki osebnih podatkov<br>Pooblaščeni trgovci, ki po potrebi izpolnijo navedene namene in ostale tretje osebe v skladu s svojimi pravnimi obveznostmi.',
        text1Bullet6: '6. Vaše pravice<br>Svojo privolitev za obveščanje lahko kadar koli prekličete tako, da o svoji odločitvi pisno ali ustno obvestite pooblaščenega trgovca ali GA Adriatic d.o.o. na elektronski naslov: <a href="mailto:SI-Nissan-AS@grandautomotive.eu">SI-Nissan-AS@grandautomotive.eu</a>. Imate pravico do dostopa do vaših osebnih podatkov, popravka, brisanja (razen če je zahteva v nasprotju z veljavno zakonodajo) in nasprotovanja obdelavi vaših osebnih podatkov, vključno s prepovedjo pošiljanja obvestil ter druge pravice, kot je razloženo v razdelku o dodatnih informacijah (v točki 8). V primeru zlorabe vaših podatkov se lahko obrnete na GA Adriatic d.o.o. na e-naslov: <a href="mailto:SI-Nissan-vop@grandautomotive.eu">SI-Nissan-vop@grandautomotive.eu</a>. Imate pravico do pravnega varstva. Lahko se obrnete na Informacijskega pooblaščenca RS.',
        text1Bullet7: '7. Rok za shranjevanje vaših osebnih podatkov<br>Osebne podatke, navedene v tej zahtevi, GA Adriatic d.o.o. sam ali izbrani pooblaščeni trgovec uporabljata za obdelavo vaše zahteve, v času, ki je potreben za izvedbo storitve, in jih hranita največ 3 leta. V primeru uporabe vaših podatkov anketiranje o zadovoljstvu se vaši podatki shranjujejo 1 leto po koncu te dejavnosti. V primeru vaše pozitivne privolitve se lahko vaši podatki združijo in povežejo z vašimi drugimi osebnimi podatki, ki jih hranimo. Upravljavec te osebnostne podatke zbira in obdeluje do preklica ali največ 30 let v skladu z določbami zakonodaje o varstvu osebnih podatkov.',
        text1Bullet8: '8. Dodatne informacije<br>Dodatne in podrobnejše informacije o varovanju vaših osebnih podatkov najdete v naši <a href="https://www.nissan.si/splosno-vop.html" target="_blank">Politiki zasebnosti</a>.',
      },
      comply: {
        yes: 'da',
        no: 'ne'
      },
      types: {
        title: 'Vrste sporočil',
        description: 'Želim prejemati osebno prilagojene ponudbe za nakup vozil in poprodajnih izdelkov in storitev ter informacije o prilagojenih ugodnostih in dogodkih in druge aktualne novice od GA Adriatic, d.o.o., ki na slovenskem trgu zastopa znamke Renault, Dacia, Nissan in Alpine ter pooblaščeni trgovci teh znamk, pri katerih se nahajajo moji podatki, po e-pošti.',
        eNews: {
          title: 'Želim prejemati osebno prilagojene ponudbe za nakup vozil in poprodajnih izdelkov in storitev ter informacije o prilagojenih ugodnostih in dogodkih in druge aktualne novice od GA Adriatic d.o.o., ki na slovenskem trgu zastopa znamke Renault, Dacia, Nissan in Alpine ter pooblaščeni trgovci teh znamk, pri katerih se nahajajo moji podatki:'
        },
        purchase: {
          title: 'Ponudbe za nakup poprodajnih izdelkov in storitev',
          tooltips: 'Želim prejemati prilagojene prodajne ponudbe za nakup nadomestnih delov, originalne dodatne opreme, servisnih storitev, pogodb o vzdrževanju, podaljšanem jamstvu in podobno.',
          error: 'Prosimo označite svoj izbor.'
        }
      },
      ePosta: {
        yes: "da",
        no: "ne",
        description: "Po e-pošti",
        error: "Prosimo označite svoj izbor"
      },
      telefon: {
        yes: "da",
        no: "ne",
        description: "Po telefonu",
        error: "Prosimo označite svoj izbor"
      },
      sms: {
        yes: "da",
        no: "ne",
        description: "Po SMS-u",
        error: "Prosimo označite svoj izbor"
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/texts.js